import { SECTION_ID } from '../../../shared/constants/sectionIds.js'
import { HERO_VIEW } from '../../../shared/constants/heroView.js'

export const MOBILE_DESTINATION_ID = {
  CATALOG: 'catalog',
  FAVORITES: 'favorites',
  GALLERY: 'gallery',
  MODEL: 'model',
  PRODUCT: 'product',
  TIERS: 'tiers',
  VISUALIZATION: 'visualization',
}

const DESTINATIONS_REGISTRY = [
  {
    id: MOBILE_DESTINATION_ID.VISUALIZATION,
    sectionId: SECTION_ID.HERO,
    heroView: HERO_VIEW.VISUALIZATION,
    isEnabled: ({ heroCapabilities }) => heroCapabilities?.hasVisualization,
  },
  {
    id: MOBILE_DESTINATION_ID.MODEL,
    sectionId: SECTION_ID.HERO,
    heroView: null,
    isEnabled: ({ heroCapabilities }) => heroCapabilities?.hasSiteModel || heroCapabilities?.hasBuildingModel,
  },
  {
    id: MOBILE_DESTINATION_ID.TIERS,
    sectionId: SECTION_ID.TIERS,
    isEnabled: ({ appCapabilities }) => appCapabilities?.tiersSectionEnabled,
  },
  {
    id: MOBILE_DESTINATION_ID.PRODUCT,
    sectionId: SECTION_ID.PRODUCT,
    isEnabled: ({ appCapabilities }) => appCapabilities?.productSectionEnabled,
  },
  {
    id: MOBILE_DESTINATION_ID.FAVORITES,
    sectionId: SECTION_ID.FAVORITES,
    isEnabled: ({ appCapabilities }) => appCapabilities?.favoritesSectionEnabled,
  },
  {
    id: MOBILE_DESTINATION_ID.CATALOG,
    sectionId: SECTION_ID.CATALOG,
    isEnabled: () => true,
  },
]

const SECTION_TO_MOBILE_DESTINATION = {
  [SECTION_ID.CATALOG]: MOBILE_DESTINATION_ID.CATALOG,
  [SECTION_ID.TIERS]: MOBILE_DESTINATION_ID.TIERS,
  [SECTION_ID.PRODUCT]: MOBILE_DESTINATION_ID.PRODUCT,
  [SECTION_ID.FAVORITES]: MOBILE_DESTINATION_ID.FAVORITES,
}

function getAllowedHeroViews(heroCapabilities) {
  const available = heroCapabilities?.availableViews
  if (!Array.isArray(available) || available.length === 0) {
    return [HERO_VIEW.VISUALIZATION, HERO_VIEW.SITE, HERO_VIEW.BUILDING]
  }

  return available
}

export function resolveMobileDestinations({ appCapabilities, heroCapabilities }) {
  return DESTINATIONS_REGISTRY.filter((destination) =>
    destination.isEnabled({ appCapabilities, heroCapabilities }),
  )
}

export function resolveActiveMobileDestination(activeSectionId, heroActiveView) {
  if (activeSectionId !== SECTION_ID.HERO) {
    return SECTION_TO_MOBILE_DESTINATION[activeSectionId] ?? MOBILE_DESTINATION_ID.CATALOG
  }

  if (heroActiveView === HERO_VIEW.VISUALIZATION) {
    return MOBILE_DESTINATION_ID.VISUALIZATION
  }

  return MOBILE_DESTINATION_ID.MODEL
}

export function resolveHeroViewForDestination(destinationId, { heroActiveView, heroCapabilities }) {
  if (destinationId === MOBILE_DESTINATION_ID.VISUALIZATION) {
    return HERO_VIEW.VISUALIZATION
  }

  if (destinationId !== MOBILE_DESTINATION_ID.MODEL) {
    return null
  }

  const allowedHeroViews = getAllowedHeroViews(heroCapabilities)

  if ((heroActiveView === HERO_VIEW.SITE || heroActiveView === HERO_VIEW.BUILDING) &&
    allowedHeroViews.includes(heroActiveView)
  ) {
    return heroActiveView
  }

  if (heroCapabilities?.initialView &&
    (heroCapabilities.initialView === HERO_VIEW.SITE || heroCapabilities.initialView === HERO_VIEW.BUILDING) &&
    allowedHeroViews.includes(heroCapabilities.initialView)
  ) {
    return heroCapabilities.initialView
  }

  if (allowedHeroViews.includes(HERO_VIEW.SITE)) return HERO_VIEW.SITE
  if (allowedHeroViews.includes(HERO_VIEW.BUILDING)) return HERO_VIEW.BUILDING

  return HERO_VIEW.VISUALIZATION
}
